export default __webpack_public_path__ + "static/media/retail-banner.68de8a27.png";